import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap";

//images
import imagePlaceholder from "../assets/images/users/user-dummy-img.jpg";
import { BasicDetailsTypes } from "../types/profile";

interface DataTypes {
  dateVisit: string | null;
  message: string | null;
  confirm: boolean;
}

interface VisitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (data: any) => void;
  chatUserDetails: BasicDetailsTypes;
}

const VisitModal = ({ isOpen, onClose, onConfirm, chatUserDetails }: VisitModalProps) => {

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate());

  const tomorrowFormatted = tomorrow.toISOString().split("T")[0];

  const [data, setData] = useState<DataTypes>({
    dateVisit: tomorrowFormatted,
    confirm: true,
    message: null,
  });

  const [dateTouched, setDateTouched] = useState(false);

  const dateIsValid = (() => {
    if (!data.dateVisit) return false;

    const [year, month, day] = data.dateVisit.split("-").map(Number);

    // cria data LOCAL
    const visitDate = new Date(year, month - 1, day);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return visitDate >= today;
  })();


  const [obsTouched, setObsTouched] = useState(false);
  const obsIsValid = (data.message?.trim().length ?? 0) > 3;

  useEffect(() => {
    setData({
      dateVisit: data.dateVisit,
      confirm: data.confirm,
      message: data.message,
    });
  }, []);

  const onChangeData = (field: "confirm" | "dateVisit" | "message", value: string | boolean) => {
    let modifiedData: any = { ...data };
    if (value === "") {
      modifiedData[field] = null;
    } else {
      modifiedData[field] = value;
    }
    setData(modifiedData);
  };

  const [valid, setValid] = useState<boolean>(false);

  useEffect(() => {
    if (obsIsValid && dateIsValid) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [data, obsIsValid, dateIsValid]);


  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      tabIndex={-1}
      centered
      className="visitModal"
      contentClassName="shadow-lg border-0"
    >
      <ModalBody className="p-0">
        <div className="text-Leftbar p-4 pb-0">
          <h5 className="font-size-18 mb-4 text-uppercase text-truncate">
            Agendamento de Visita
          </h5>


          <Form>

            <div className="mb-3 d-flex align-items-end gap-4">

              {/* Data da visita */}
              <div className="w-50">
                <Label
                  htmlFor="AddContactModalidCliente-input"
                  className="form-label"
                >
                  Data da visita
                </Label>
                <Input
                  type="date"
                  value={data.dateVisit || ""}
                  valid={dateTouched && dateIsValid}
                  invalid={dateTouched && !dateIsValid}
                  onBlur={() => setDateTouched(true)}
                  onChange={(e) => {
                    onChangeData("dateVisit", e.target.value);
                  }}
                />
                {dateTouched && !dateIsValid && (
                  <div className="invalid-feedback d-block">
                    Informe data da visita
                  </div>
                )}
              </div>

              {/* Confirmar template */}
              <div className="d-flex flex-column align-items-start">

                <Label
                  className="form-check-label mb-2"
                  htmlFor="privacy-lastseenSwitch"
                >
                  Confirmação
                </Label>

                <div className="form-check form-switch m-0">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="privacy-lastseenSwitch"
                    checked={data.confirm === true}
                    onChange={(e: any) => {
                      onChangeData("confirm", e.target.checked);
                    }}
                  />
                  WhatsApp
                </div>
              </div>
            </div>

            <div className="">
              <Label
                htmlFor="AddContactModal-invitemessage-input"
                className="form-label"
              >
                Observação da visita
              </Label>
              <Input
                type="textarea"
                value={data.message || ""}
                valid={obsTouched && obsIsValid}
                invalid={obsTouched && !obsIsValid}
                onBlur={() => setObsTouched(true)}
                onChange={(e) => onChangeData("message", e.target.value)}
                className="form-control"
                id="AddContactModal-invitemessage-input"
                rows={3}
                placeholder="Visita na residência às 14:00hrs"
              />

              {obsTouched && !obsIsValid && (
                <div className="invalid-feedback d-block">
                  Informe uma observação
                </div>
              )}
            </div>
          </Form>

          <div className="mt-4 d-flex justify-content-center gap-4">
            <Button
              type="button"
              className="btn btn-primary avatar-md call-close-btn rounded-circle"
              color="primary"
              disabled={!valid}
              onClick={() => onConfirm(data)}
            >
              <span className="avatar-title bg-transparent font-size-24">
                <i className="bx bxs-calendar-check"></i>
              </span>
            </Button>

            <Button
              type="button"
              className="btn btn-danger avatar-md call-close-btn rounded-circle"
              color="danger"
              onClick={onClose}
            >
              <span className="avatar-title bg-transparent font-size-24">
                <i className="bx bx-window-close"></i>
              </span>
            </Button>
          </div>



        </div>

        <div className="p-4 bg-soft-primary mt-n4">
          <div className="mt-4 text-Leftbar">
            <h5 className="font-size-14 text-uppercase text-muted mt-2">
              {chatUserDetails ? `ID: ${chatUserDetails.idCliente}` : ""}
            </h5>
            <h5 className="font-size-14 text-uppercase text-muted mt-2">
              {chatUserDetails ? `CPF: ${chatUserDetails.cpfCnpj}` : ""}
            </h5>
            <h5 className="font-size-14 text-uppercase text-muted mt-2">
              {chatUserDetails ? `Região: ${chatUserDetails.regiao}` : ""}
            </h5>
          </div>

          <div className="mt-4 text-Leftbar">
            <h5 className="font-size-18 mb-0 text-truncate">
              {chatUserDetails ? `${chatUserDetails.fullName}` : ""}
            </h5>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VisitModal;
